import React from "react";

import mask from "../logo/Mask.jpg";
import martin from "../logo/Harry.jpg";
import rockstar from "../logo/Rockstar.jpg";
import { motion } from "framer-motion";

const item = {
  hidden: {
    opacity: 0,
    y: 400,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1,
    },
  },
};
const img1 = {
  hidden: {
    rotate: 0,
  },
  visible: {
    rotate: -20,
    x: 80,
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1,
    },
  },
};
const img2 = {
  hidden: {
    rotate: 0,
  },
  visible: {
    rotate: 20,
    x: -80,
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1,
    },
  },
};
const Bio = () => {
  return (
    <>
      <section id="bio">
        <div className="bioContainer">
          <motion.div
            className="bio-wrapper"
            variants={item}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2>
              I have a passion for creating new designs ,illustrations & user
              experiences that are seamless and impactful.
            </h2>

            <motion.div className="imageBox martin">
              <motion.img
                variants={img1}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                src={martin}
                alt="illustration"
              />
            </motion.div>
            <div className="imageBox mask">
              <motion.img src={mask} alt="illustration" />
            </div>
            <div className="imageBox rock">
              <motion.img
                variants={img2}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                src={rockstar}
                alt="illustration"
              />
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default Bio;
